webpackJsonp([215163933632717],{

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ThemeNavFooter = __webpack_require__(104);
	
	var _ThemeNavFooter2 = _interopRequireDefault(_ThemeNavFooter);
	
	var _ShareExhibit = __webpack_require__(85);
	
	var _ShareExhibit2 = _interopRequireDefault(_ShareExhibit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  Components
	var Conclusion = function Conclusion(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'h1',
	        { className: 'title__page' },
	        'Conclusion'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'The ',
	              _react2.default.createElement(
	                'em',
	                null,
	                '2019 Scorecard on State Health System Performance'
	              ),
	              ' shows that states and the federal government face important challenges in promoting affordable health care and the best possible health outcomes for people across the country.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'The widespread gains in expanding health insurance coverage and access to care following the 2010 passage of the Affordable Care Act have largely stalled since 2015; in 16 states, these coverage gains slightly eroded between 2016 and 2017. There are several reasons for this stalled progress and backsliding: lack of Medicaid expansion in 17 states; the fact that individual-market insurance remains unaffordable for many, including those with incomes just over the eligibility threshold for marketplace subsidies (about $48,560 for an individual); and growing out-of-pocket costs for many with private plans, including employer plans. What\u2019s more, recent congressional and executive actions related to the individual health insurance market and Medicaid have curtailed enrollment in both. Finally, undocumented immigrants are ineligible for subsidized coverage.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'At the same time, health care costs in employer plans continue to grow at a faster clip than median income, leaving many families paying more for their insurance but getting less.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Most alarming, in some states residents now face shorter life expectancies than just a few years ago, in part because of unrelenting increases in deaths linked to suicide, alcohol, and drug overdose.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'exhibit-16', className: 'section__content section__exhibit section__exhibit__padded section__full' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title__block' },
	            'National gains if all states achieved top rates* of performance'
	          ),
	          _react2.default.createElement(
	            'figure',
	            null,
	            _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-16-web.png'), alt: '' }),
	            _react2.default.createElement(
	              'figcaption',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                '* Performance benchmarks set at the level achieved by the top-performing state with available data for this indicator.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'sup',
	                  null,
	                  'a'
	                ),
	                'Estimate based on working-age population, ages 18\u201364, with employer-sponsored insurance, and Medicare beneficiaries age 65 and older.'
	              )
	            )
	          ),
	          _react2.default.createElement(_ShareExhibit2.default, {
	            exhibit: 'exhibit-16',
	            site: data.site.siteMetadata,
	            social: data.allSocialJson.edges })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section section__centered section__narrow' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'All states can improve, including those that topped our ',
	            _react2.default.createElement(
	              'em',
	              null,
	              'Scorecard'
	            ),
	            ' rankings.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Indeed, many states are already taking important steps to expand access to high-quality care by:'
	          )
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'section__divider' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Expanding access to care'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide' },
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Expanding Medicaid eligibility',
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'As of June 2019, 33 states and the District of Columbia have expanded eligibility for their Medicaid programs to more low-income adults. In November 2018, voters in Idaho, Nebraska, and Utah passed ballot initiatives to do so, but lawmakers in these states have since taken steps to restrict the expansion.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'However, 15 states, including eight that expanded Medicaid eligibility, have approved or pending waivers that allow them to make work status a requirement for Medicaid coverage. This will likely further erode coverage gains among adults with low incomes. Two of the approved waivers, in Arkansas and Kentucky, were blocked by court rulings, but not before more than 18,000 Arkansans lost their health coverage.',
	                    _react2.default.createElement(
	                      'sup',
	                      { className: 'note__link' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: '#22' },
	                        '22'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Ensuring well-functioning individual insurance markets',
	                _react2.default.createElement(
	                  'sup',
	                  { className: 'note__link' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#23' },
	                    '23'
	                  )
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'The Affordable Care Act\u2019s reinsurance program, which protected insurers against unexpectedly high claims and helped to reduce marketplace premiums, expired at the end of 2016. Seven states are now operating their own reinsurance programs to stabilize and strengthen their individual insurance market; Alaska\u2019s program reduced premiums by 20 percent in 2018.',
	                    _react2.default.createElement(
	                      'sup',
	                      { className: 'note__link' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: '#24' },
	                        '24'
	                      )
	                    ),
	                    ' Additional states are seeking federal approval to establish reinsurance programs. Several congressional bills include proposals for reinstating a federal reinsurance program.',
	                    _react2.default.createElement(
	                      'sup',
	                      { className: 'note__link' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: '#25' },
	                        '25'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'section__divider' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Taking steps to mitigate health care cost growth'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide' },
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Some health reform bills recently introduced in Congress propose to lower U.S. health care costs by paying providers at or near Medicare rates.',
	                _react2.default.createElement(
	                  'sup',
	                  { className: 'note__link' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#26' },
	                    '26'
	                  )
	                ),
	                ' The health reform bills that would use Medicare payment rates include single-payer or Medicare-for-All proposals, as well as those that give consumers a choice of enrolling in a Medicare-like public plan. Some states are attempting similar reforms. Washington will launch a public-plan option in 2021 that will cap what providers are paid at 160 percent of Medicare rates. Some states including New Mexico are crafting a Medicaid buy-in option. But paying providers in employer and other private insurance plans at or near Medicare rates could be put in place without a public plan or single-payer system.',
	                _react2.default.createElement(
	                  'sup',
	                  { className: 'note__link' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#27' },
	                    '27'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Several states are using value-based purchasing in their Medicaid and state employee benefits programs in order to promote higher-quality, lower-cost care.',
	                _react2.default.createElement(
	                  'sup',
	                  { className: 'note__link' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#28' },
	                    '28'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Colorado, Michigan, and Oklahoma are changing the way they pay for prescription drugs in Medicaid by requesting federal waivers to negotiate with drugmakers based on how well the drug works, rather than accepting market pricing.',
	                _react2.default.createElement(
	                  'sup',
	                  { className: 'note__link' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#29' },
	                    '29'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Some states are promoting secure and efficient platforms for health care providers, health plans, and state programs to exchange information in order to monitor and improve health care quality.',
	                _react2.default.createElement(
	                  'sup',
	                  { className: 'note__link' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#30' },
	                    '30'
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'section__divider' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Promoting the best possible outcomes'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide' },
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Several states are working to build an adequate primary care workforce, especially in underserved areas, by offering tuition assistance, changing the scope of practice laws, raising the primary care reimbursement rate, and other steps.',
	                _react2.default.createElement(
	                  'sup',
	                  { className: 'note__link' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#31' },
	                    '31'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Working in partnership with the federal government, states have an opportunity to do more in developing and implementing new initiatives to curb the opioid crisis. State efforts to counter the surge in drug overdose deaths include improving access to opioid overdose reversal medications such as naloxone \u2014 efforts that have been bolstered by Medicaid expansion \u2014 and passed legislation that sets guidelines or limits for opioid prescriptions.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#32' },
	                  '32'
	                )
	              ),
	              ' These are important steps, but there is more to be done in preventing and treating opioid use disorder and responding to overdoses. Reversing the upward trend in deaths from suicide, alcohol, and drug overdose will require greater cooperation across sectors, at both the state and federal level, including the public health, care delivery, and criminal justice systems.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#33' },
	                  '33'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Ultimately, national improvement in health system performance will require the support of the federal government. States with fewer resources and those that are less engaged in efforts to expand insurance coverage, reduce health care costs, and improve care quality will continue to lag others. Some states that have taken steps to improve, for example by implementing reinsurance programs to lower premiums, are struggling to finance their efforts over the long term.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'While many states have assumed greater responsibility for improving health system performance in recent years, they will need a strong federal partnership to build and sustain their progress.'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_ThemeNavFooter2.default, { themes: data.allThemesJson.edges }),
	    _react2.default.createElement(
	      'div',
	      { className: 'section section__notes' },
	      _react2.default.createElement(
	        'div',
	        { className: 'section__row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content' },
	          _react2.default.createElement(
	            'ol',
	            { start: '22', style: { counterReset: "item 21" }, className: 'list__notes' },
	            _react2.default.createElement(
	              'li',
	              { id: '22' },
	              'Collins, Bhupal, and Doty, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Health Insurance Coverage Eight Years'
	              ),
	              ', 2019.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '23' },
	              'Sabrina Corlette, Kevin Lucia, and Maanasa Kona, \u201C',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.commonwealthfund.org/blog/2017/states-step-protect-consumers-wake-cuts-aca-cost-sharing-reduction-payments?redirect_source=/publications/blog/2017/oct/states-protect-consumers-in-wake-of-aca-cost-sharing-payment-cuts' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'States Step Up to Protect Consumers in Wake of Cuts to ACA Cost-Sharing Reduction Payments'
	                )
	              ),
	              ',\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'To the Point'
	              ),
	              ' (blog), Commonwealth Fund, Oct. 27, 2017; and Justin Giovannelli and Ashley Williams, \u201C',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.commonwealthfund.org/blog/2017/regulation-narrow-networks-federal-protections-jeopardy-state-approaches-take-added' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Regulation of Narrow Networks: With Federal Protections in Jeopardy, State Approaches Take on Added Significance'
	                )
	              ),
	              ',\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'To the Point'
	              ),
	              ' (blog), Commonwealth Fund, Feb. 2, 2017.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '24' },
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.commonwealthfund.org/publications/maps-and-interactives/2019/may/what-your-state-doing-affect-access-adequate-health' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'What Is Your State Doing to Affect Access to Adequate Health Insurance?'
	                  )
	                )
	              ),
	              ', interactive map (Commonwealth Fund, last updated May 30, 2019).'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '25' },
	              'Collins, Bhupal, and Doty, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Health Insurance Coverage Eight Years'
	              ),
	              ', 2019; and David Blumenthal et al., \u201C',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.commonwealthfund.org/blog/2018/states-take-lead-reinsurance-stabilize-aca-marketplaces' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'States Take the Lead on Reinsurance to Stabilize the ACA Marketplaces'
	                )
	              ),
	              ',\u201D To the Point (blog), Commonwealth Fund, May 22, 2018.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '26' },
	              'Sara R. Collins and Roosa Tikkanen, \u201C',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.commonwealthfund.org/many-varieties-universal-coverage' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'The Many Varieties of Universal Coverage'
	                )
	              ),
	              ',\u201D Commonwealth Fund, last updated Apr. 24, 2019.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '27' },
	              'Sara R. Collins, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.commonwealthfund.org/publications/2019/apr/testimony-health-insurance-recent-congressional-reform-bills' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Status of U.S. Health Insurance Coverage and the Potential of Recent Congressional Health Reform Bills to Expand Coverage and Lower Consumer Costs'
	                  )
	                )
	              ),
	              ', Invited Testimony, U.S. House of Representatives Committee on Rules, Hearing on \u201CMedicare for All Act of 2019,\u201D Apr. 30, 2019.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '28' },
	              'Bailit Health, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://medicaiddirectors.org/wp-content/uploads/2016/03/NAMD_Bailit-Health_Value-Based-Purchasing-in-Medicaid.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'The Role of State Medicaid Programs in Improving the Health Care System'
	                  )
	                )
	              ),
	              ' (National Association of Medicaid Directors, Mar. 2016); Michael Bailit, Megan Burns, and Mary Beth Dyer, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.shvs.org/resource/value-based-innovation-by-state-public-employee-health-benefits-programs/' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Value-Based-Innovation by State Public Employee Health Benefits Programs'
	                  )
	                )
	              ),
	              ' (Bailit Health, for State Health and Value Strategies, Princeton University Woodrow Wilson School of Public and International Affairs, Nov. 2017); and Trish Riley et al., ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://nashp.org/wp-content/uploads/2019/04/States-Leverage-Purchasing-Power.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Cross-Agency Strategies to Curb Health Care Costs: Leveraging State Purchasing Power'
	                  )
	                )
	              ),
	              ' (National Academy for State Health Policy, Apr. 2019).'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '29' },
	              '\u201C',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.modernhealthcare.com/article/20190225/NEWS/190229950/cms-oks-colorado-s-waiver-for-medicaid-value-based-purchasing' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'CMS OKs Colorado\u2019s Waiver for Medicaid Value-Based Purchasing'
	                )
	              ),
	              ',\u201D Modern Healthcare, Feb. 25, 2019.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '30' },
	              'National Governors Association, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://natlgovassoc.wpengine.com/wp-content/uploads/2018/07/1612HealthCareRightInformation.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Getting the Right Information to the Right Health Care Providers at the Right Time: A Road Map for States to Improve Health Information Flow Between Providers'
	                  )
	                )
	              ),
	              ' (NGA Center for Best Practices, Dec. 2016).'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '31' },
	              'National Conference of State Legislatures, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.ncsl.org/documents/health/PCWorkforceTK13.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Primary Care Workforce: Health Care Safety-Net Toolkit for Legislators'
	                  )
	                )
	              ),
	              ' (NCSL, 2013).'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '32' },
	              'Richard G. Frank and Carrie E. Fry, \u201C',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.commonwealthfund.org/publications/journal-article/2019/may/medicaid-expansion-states-more-people-had-access-opioid' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'The Impact of Expanded Medicaid Eligibility on Access to Naloxone'
	                )
	              ),
	              ',\u201D Addiction, published online Apr. 14, 2019; and National Conference of State Legislators, \u201C',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.ncsl.org/research/health/prescribing-policies-states-confront-opioid-overdose-epidemic.aspx' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Prescribing Policies: States Confront Opioid Overdose Epidemic'
	                )
	              ),
	              ',\u201D NCSL, last updated Oct. 31, 2018.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '33' },
	              'National Governors Association, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://classic.nga.org/files/live/sites/NGA/files/pdf/2016/1607NGAOpioidRoadMap.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Finding Solutions to the Prescription Opioid and Heroin Crisis: A Road Map for States'
	                  )
	                )
	              ),
	              ' (NGA Center for Best Practices, July 2016).'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Conclusion;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-conclusion-js-432c34bbfa1d965d0eb5.js